export default (theme) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    figure: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: 1.88,
        margin: '0 0 16px',
        '& > img': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
});
